<template>
  <div class="deny-reason-config">
    <p v-if="label" class="subtitle-2 label">{{ label }}</p>
    <dataTable :headers="headers" :items="tableItems">
      <template v-slot:item="{ item, index }">
        <tr>
          <td>
            <configField
              :id="ruleId"
              :field="item"
              :category="category"
              :index="index"
              :value="getConfigValue(item.FieldId)"
              :rules="validationRules"
              @setConfigValue="setConfigValue"
              emitSetConfig
              hideLabel
            />
          </td>
          <td>
            <p v-if="item.appliesTo">{{ item.appliesTo }}</p>
          </td>
        </tr>
      </template>
    </dataTable>
  </div>
</template>
<script>
/**
 * @fileoverview Config input field for simple tables
 *
 * @author Dan Kenemer <dan.kenemer@quavo.com>
 */

import dataTable from "@/qux-common/qux22/components/organisms/data-table";
import getValidationRules from "@/util/getValidationRules";
import fieldMap from "./field-map.json";
import { mapGetters } from "vuex";

export default {
  name: "DenyReasonConfigField",
  components: {
    dataTable,
    configField: () => import("../config-field"),
  },
  props: {
    availableFieldList: {
      type: Array,
    },
    category: {
      type: String,
    },
    id: {
      type: String,
    },
    label: {
      type: String,
    },
    rules: {
      type: Array,
    },
    ruleId: {
      type: String,
    },
    value: {
      type: [String, Object, Number, Boolean, Array],
    },
    parentField: {
      type: String,
    },
  },
  methods: {
    getConfigValue(id) {
      return (
        this.mergedConfig[this.ruleId] &&
        this.mergedConfig[this.ruleId][this.category] &&
        this.mergedConfig[this.ruleId][this.category][this.id] &&
        this.mergedConfig[this.ruleId][this.category][this.id][id]
      );
    },
    setConfigValue(value) {
      let valueObject = {};
      valueObject[value.fieldId] = value.value;
      this.$emit("setConfigValue", valueObject);
    },
    getFieldValue(value, id = this.id) {
      return (
        fieldMap[this.category] &&
        fieldMap[this.category][id] &&
        fieldMap[this.category][id][value]
      );
    },
    getFieldIsVisible(field) {
      const visible =
        this.configVisibility[this.ruleId] &&
        this.configVisibility[this.ruleId][this.category] &&
        this.configVisibility[this.ruleId][this.category][field.FieldId];
      return (visible);
    },
  },
  computed: {
    tableItems() {
      let theResult = [];
      for (const currItem of this.availableFieldList) {
        const appliesTo =
          fieldMap[this.category] &&
          fieldMap[this.category][currItem.FieldId] &&
          fieldMap[this.category][currItem.FieldId]["appliesTo"];
        if (appliesTo) {
          currItem.appliesTo = appliesTo;
        }
        if (this.getFieldIsVisible(currItem)) {
          theResult.push(currItem);
        }
      }
      return theResult;
    },
    headers() {
      return this.getFieldValue("columnHeaders") !== undefined
        ? this.getFieldValue("columnHeaders")
        : [];
    },
    validationRules() {
      return getValidationRules({
        rules: this.rules,
        inputErrorMessage: this.getFieldValue("inputErrorMessage"),
      });
    },
    ...mapGetters({
      configVisibility: "getConfigVisibility",
      mergedConfig: "getMergedConfig",
    }),
  },
};
</script>


<style lang="scss" scoped>
.deny-reason-config {
  margin-bottom: $qvo-spacing-24;
  p.label {
    margin-bottom: $qvo-spacing-24;
  }
  .v-data-table {
    max-width: 650px;
    &::v-deep {
      .config-field {
        margin-bottom: 0;
      }
    }
  }
}
</style>